const overrides: Record<string, string> = {};

export function translateCategoryName(name: string): string {
  if (!name) return name;
  return overrides[name] ?? name;
}
